import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('CheckboxesContainer')(() => css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'm',
}));
themeStyles.addBaseStyles('OfferTitleWrapper')(() => css({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    gap: 'xs',
    my: '10px',
    ml: 'm',
}));
themeStyles.addBaseStyles('StyledTooltip')(() => css({
    alignSelf: 'flex-start',
    display: 'inline-flex',
    verticalAlign: 'top',
    ml: '8px',
}));
export default themeStyles;
